import { Link } from "react-router";
import { employeePath } from "@/lib/staff-paths";

interface EmployeeLinkProps {
  employee: { id: string; vendorId: string; firstName: string; lastName: string };
}

/** An employee's name, linked to their page. */
export function EmployeeLink({ employee }: EmployeeLinkProps): React.ReactElement {
  return (
    <Link to={employeePath(employee.vendorId, employee.id)} className="font-medium text-blue-700 hover:text-blue-900 hover:underline">
      {employee.firstName} {employee.lastName}
    </Link>
  );
}
